import JsonLd from 'marketplace-ui-common/components/elements/JsonLd';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import { useParams } from 'quartz-routing/react-router';
import { useMemo } from 'react';
import { Paths } from '../../constants/paths';
import { getFullPublicUrl } from '../../utils/urls';
import { getBreadcrumbConfig } from '../constants/breadcrumbConfig';
import { useBreadcrumbs } from '../hooks/useBreadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
const getItemName = (itemPathKey, title) => {
  const config = getBreadcrumbConfig()[itemPathKey];
  if (config) return config.text;
  return String(title || '');
};
export function StorefrontBreadcrumbStructuredData({
  pathKey,
  productType,
  title
}) {
  const {
    collectionSlug,
    listingSlug
  } = useParams();
  const items = useBreadcrumbs({
    pathKey,
    productType,
    slug: collectionSlug || listingSlug,
    title
  });
  const item = useMemo(() => {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [...items.map((element, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': getFullPublicUrl(element.slug || Paths[element.pathKey]),
          name: getItemName(element.pathKey, title)
        }
      }))]
    };
  }, [items, title]);
  return /*#__PURE__*/_jsx(DocumentHead, {
    children: /*#__PURE__*/_jsx(JsonLd, {
      item: item
    })
  });
}